import { battleLogic } from "../util/battleLogic";
import normalizeData from '../util/normalizeData';
import { transformDna } from '../util/transformDna';
import * as newCardLogic from "../util/newCardLogic";
import { contractAddress, nebPay, neb, api } from "../util/nebulas";
import { source } from "../util/nrc271_source";

const fromAddress = 'n1Rhm86wrRECeuT7suiituRc7EonzChvBEe';

export default {

    // ************* \\
    // - INIT DATA - \\
    // ************* \\

    initBlockchainData ({ dispatch, commit }) {

        dispatch('initTokens');
         
    },

    initTokens ({ commit }) {

        return new Promise((resolve, reject) => {      
            let itemsArray = [];
            
            api
            .call({
                chainID: 1,
                from: fromAddress,
                to: contractAddress,
                value: 0,
                nonce: 1,
                gasPrice: 1000000,
                gasLimit: 2000000,
                contract: {
                    function: 'tokensRegistered',
                    args: '',
                },
            })
            .then(function(data) {


                const len = parseInt(data.result);
                let errorCount = 0;

                // Update created cards counter
                commit('setRegisteredTokens', { registeredTokens: len });
                // commit('setCardCounterLoading', { loading: false });

                api
                .call({
                    chainID: 1,
                    from: fromAddress,
                    to: contractAddress,
                    value: 0,
                    nonce: 1,
                    gasPrice: 1000000,
                    gasLimit: 2000000,
                    contract: {
                        function: 'getTokens',
                        args: '',
                    },
                })
                .then(function(data) {

                    // Catch a bad response
                    if (!data.result) {

                        errorCount += 1;
                        console.log('error', 'cards', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                    } else {

                        itemsArray = JSON.parse(data.result);                     
                        resolve({
                            items: itemsArray,
                            message: 'success'
                        });

                    }

                });

            });
        
        }).then((returnObject) => {
    
            commit('setTokens', { tokens: returnObject.items });

        });

    },

    getTokenByContract ({ commit }, payload) {

        return new Promise((resolve, reject) => {  
            const address = payload.address;
            const args = "[\"" + address + "\"]";

            api
            .call({
                chainID: 1,
                from: fromAddress,
                to: contractAddress,
                value: 0,
                nonce: 1,
                gasPrice: 1000000,
                gasLimit: 2000000,
                contract: {
                    function: 'getTokenByContract',
                    args: args,
                },
            })
            .then(function(data) {
                // Catch a bad response
                if (!data.result) {

                    console.log('error', 'token', data);
                    commit('setHasError', { error: {
                        status: true,
                        message: data
                    }});

                    resolve({ message: 'error' });

                } else {

                    let token = JSON.parse(data.result);
                    commit('setToken', { token });

                    resolve({
                        message: 'success',
                        token
                    });

                }
            });

        });

    },

    getContractDetails ({ commit }, payload) {

        return new Promise((resolve, reject) => {  
            const address = payload.address;

            api
            .call({
                chainID: 1,
                from: fromAddress,
                to: address,
                value: 0,
                nonce: 1,
                gasPrice: 1000000,
                gasLimit: 2000000,
                contract: {
                    function: 'details',
                    args: '',
                },
            })
            .then(function(data) {

                // Catch a bad response
                if (!data.result) {

                    console.log('error', 'token', data);
                    commit('setHasError', { error: {
                        status: true,
                        message: data
                    }});

                    resolve({ message: 'error' });

                } else {

                    let contractDetails = JSON.parse(data.result);
                    commit('setContractDetails', { contractDetails })

                    resolve({
                        message: 'success',
                        contractDetails
                    });

                }

            });
 
        });

    },

    getContractTokens ({ commit }, payload) {

        return new Promise((resolve, reject) => {  
            const address = payload.address;

            api
            .call({
                chainID: 1,
                from: fromAddress,
                to: address,
                value: 0,
                nonce: 1,
                gasPrice: 1000000,
                gasLimit: 2000000,
                contract: {
                    function: 'tokens',
                    args: '',
                },
            })
            .then(function(data) {

                // Catch a bad response
                if (!data.result) {

                    console.log('error', 'token', data);
                    commit('setHasError', { error: {
                        status: true,
                        message: data
                    }});

                    resolve({ message: 'error' });

                } else {

                    let contractTokens = JSON.parse(data.result);
                    commit('setContractTokens', { contractTokens });

                    resolve({
                        message: 'success',
                        contractTokens
                    });

                }

            });

        });

    },

    mintContractToken ({ commit }, payload) {
        return new Promise((resolve, reject) => {    
            const address = payload.address;
            const price = parseFloat(payload.price);

            // Update pending status
            commit('updatePendingTransaction', { status: true });

            nebPay.call(address, price, 'mint', "", {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {
                                        let eventData;

                                        for (let i = 0; i < result.events.length; i++) {
                                            if (result.events[i].topic == 'chain.contract.mintEvent') {
                                                eventData = result.events[i].data;
                                                break;
                                            }
                                        }

                                        let token = JSON.parse(eventData).Mint; 

                                        // Update pending status
                                        commit('updatePendingTransaction', { status: false });
                                        commit('addContractToken', { token });

                                        resolve({ message: 'success', token });

                                    });

                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error', token: {} });

                                    // Update pending status
                                    commit('updatePendingTransaction', { status: false });

                            });
                    }, 3000);
                }
            });
        });
    },

    registerContract ({ commit }, payload) {
        //_name, _symbol, _address, _imageUrl, _websiteUrl, _description

        const args = [ 
            payload.name, 
            payload.symbol, 
            payload.contract, 
            payload.imageUrl, 
            payload.websiteUrl, 
            payload.description 
        ];

        const deployArgs = JSON.stringify(args);

        return new Promise((resolve, reject) => {    
            // Update pending status
            commit('updatePendingTransaction', { status: true });

            nebPay.call(contractAddress, 0, 'register', deployArgs, {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {
                                        let token = JSON.parse(result.events[0].data).Register; 
                                        
                                        // Update pending status
                                        commit('updatePendingTransaction', { status: false });
                                        commit('incrementRegisteredTokens');
                                        commit('addToken', { token });

                                        resolve({ message: 'success', token });

                                    });

                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error', token: {} });

                                    // Update pending status
                                    commit('updatePendingTransaction', { status: false });

                            });
                    }, 3000);
                }
            });
        });
    },

    deployContract ({ commit }, payload) {
        const args =  [ 
            payload.name, 
            payload.price,
            payload.symbol,
            payload.supply,
            payload.license,
            payload.imageUrl,
            payload.dnaLength 
        ];

        const deployArgs = JSON.stringify(args);
        return new Promise((resolve, reject) => {  
            // Update pending status
            commit('updatePendingTransaction', { status: true });

            nebPay.deploy(source, "js", deployArgs, {
                listener: function(data) {  
                    commit('setContract', { contract: data.contract_address });

                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {

                                    clearInterval(pollApi);
                                    resolve({ message: 'success', contract: data.contract_address });

                                    // Update pending status
                                    commit('updatePendingTransaction', { status: false });

                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                                // Update pending status
                                commit('updatePendingTransaction', { status: false });

                            });
                    }, 3000);
                }
            });
        });    
    },

    // ********* \\
    // - CARDS - \\
    // ********* \\

    initCards ({ commit, getters }) {
        return new Promise((resolve, reject) => {      
            let localObject;
            let cardArray = [];
            let userCardArray = [];
            
            nebPay.simulateCall(contractAddress, 0, 'getCardCounter', "", {
                listener: function(data) {

                    const len = parseInt(data.result);
                    let errorCount = 0;

                    // Update created cards counter
                    commit('setCardsCreated', { cardsCreated: len });
                    commit('setCardCounterLoading', { loading: false });

                    nebPay.simulateCall(contractAddress, 0, 'getAllCards', "", {
                        listener: function(data) {  
                            
                            // Catch a bad response
                            if (!data.result) {

                                errorCount += 1;
                                console.log('error', 'cards', data);
                                commit('setHasError', { error: {
                                    status: true,
                                    message: data
                                }});

                            } else {

                                cardArray = JSON.parse(data.result);
                                cardArray = transformDna(cardArray);
                                        
                                for (let i = 0; i < cardArray.length; i++) {

                                    if (getters.getUser.address == cardArray[i].owner) {
                                        userCardArray.push(cardArray[i]);
                                    }

                                }

                                resolve({
                                    allCards: cardArray,
                                    userCards: userCardArray
                                });

                            }

                        }
                    });
                }
            });
        
        }).then((cardsObject) => {
            commit('setCards', { cards: cardsObject.userCards });
            commit('setAllCards', { cards: cardsObject.allCards }); 

            commit('setCardLoading', { loading: false });
        });
    },

    // FETCH DATA 
    getCard ({ commit }, payload) {

        return new Promise((resolve, reject) => {  
            const id = payload.id;
            const args = "[\"" + id + "\"]";

            nebPay.simulateCall(contractAddress, 0, 'getCard', args, {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        console.log('error', 'cards', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                        resolve({ message: 'error' });

                    } else {

                        let card = JSON.parse(data.result);
                        card = transformDna([card])[0];
                        
                        resolve({
                            message: 'success',
                            card
                        });

                    }
                }
            });

        });
        
    },

    getCardsByRange ({ commit }, payload) {

        return new Promise((resolve, reject) => {  
            
            const args = "[" + payload.start + "," + payload.end + "]";
            nebPay.simulateCall(contractAddress, 0, 'getCardsByRange', args, {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        console.log('error', 'cards', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                        resolve({ cards: [], message: 'error' });

                    } else {

                        let cards = JSON.parse(data.result);
                        cards = transformDna(cards);
                        
                        console.log('by range =', cards)

                        resolve({
                            cards, message: 'success'
                        });

                    }
                }
            });

        });

    },

    getAllCardsByAddress ({ commit, getters }, payload) {
        return new Promise((resolve, reject) => {  
            
            const address = payload.address;
            const args = "[\"" + address + "\"]";

            if (!address) {
                return resolve({ userCards: [] });
            };

            nebPay.simulateCall(contractAddress, 0, 'getCardsByAddress', args, {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        console.log('error', 'cards', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                        resolve({ userCards: [] });

                    } else {

                        let userCards = JSON.parse(data.result);
                        userCards = transformDna(userCards);
                        
                        resolve({
                            userCards: userCards
                        });

                    }
                }
            });

        });
        
    },

    getCardGroupById ({ commit }, payload) {
        return new Promise((resolve, reject) => {  
            
            const args = JSON.stringify(payload.ids);
            nebPay.simulateCall(contractAddress, 0, 'getCardGroupById', args, {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        console.log('error', 'cards', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                        resolve({ cards: [] });

                    } else {

                        let itemArray = JSON.parse(data.result);
                        itemArray = transformDna(itemArray);
                        
                        resolve({
                            cards: itemArray
                        });

                    }
                }
            });

        });
    },

    createCard ({ commit, state }, payload) {
        return new Promise((resolve, reject) => {     
            nebPay.call(contractAddress, 0.01, 'createRandomCard', "", {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {
                                        let eventData;

                                        for (let i = 0; i < result.events.length; i++) {
                                            if (result.events[i].topic == 'chain.contract.createCard') {
                                                eventData = result.events[i].data;
                                                break;
                                            }
                                        }

                                        let card = JSON.parse(eventData).CreateCard;                                      
                                        
                                        card = transformDna([ card ])[0];                                        
                                        commit("incrementCardCounter");
                                        commit('addToAllCards', { card });

                                        // User specific cards
                                        if (state.user.address == card.owner) {
                                            commit('addToCards', card);
                                        }

                                        resolve({ message: 'success', card });

                                    })
                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error', card: {} });

                            });
                    }, 3000);
                }
            });
        });
    },

    createLimitedEditionCard ({ commit }, payload) {

        const dna = JSON.stringify(payload.dna);
        const level = payload.level;

        const args = "[" + dna + "," + level + "]";
        return new Promise((resolve, reject) => {     
            
            nebPay.call(contractAddress, 0, 'createLimitedEditionCard', args, {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    
                                    clearInterval(pollApi);
                                    resolve({ message: 'success' });

                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                            });
                    }, 3000);
                }
            });

        });  

    },

    transferCard ({ commit }, payload) {
        const id = payload.id;
        const to = JSON.stringify(payload.to);

        const args = "[" + null + "," + to + "," + id + "]";
        return new Promise((resolve, reject) => {     
            
            nebPay.call(contractAddress, 0, 'transferFrom', args, {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    
                                    clearInterval(pollApi);

                                    commit('removeFromCardsById', { id });
                                    resolve({ message: 'success' });

                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                            });
                    }, 3000);
                }
            });

        });    
    },

    levelupCard ({ commit }, payload) {
        const id = payload.id;
        const levels = payload.levels;

        const args = "[" + id + "," + levels + "]";
        return new Promise((resolve, reject) => {     
            
            nebPay.call(contractAddress, 0, 'levelUpCard', args, {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    
                                    clearInterval(pollApi);
                                    
                                    commit('subtractUserTokens', { levels });
                                    commit('levelupCardByLevels', { id, levels });
                                    resolve({ message: 'success' });

                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                            });
                    }, 3000);
                }
            });

        }); 
    },

    // ************ \\
    // - AUCTIONS - \\
    // ************ \\

    initAuctions ({ commit, state }, payload) {
        new Promise((resolve, reject) => {      
            let itemArray = [];

            nebPay.simulateCall(contractAddress, 0, 'getAuctionCounter', "", {
                listener: function(data) {
                    const len = parseInt(data.result);
                    let errorCount = 0;

                    nebPay.simulateCall(contractAddress, 0, 'getAllAuctions', "", {
                        listener: function(data) {  

                            // Catch a bad response
                            if (!data.result) {

                                errorCount += 1;
                                console.log('error', 'auctions', data);
                                commit('setHasError', { error: {
                                    status: true,
                                    message: data
                                }});

                            } else {

                                itemArray = JSON.parse(data.result);

                                for (let i = 0; i < itemArray.length; i++) {
                                    itemArray[i].card = transformDna([itemArray[i].card])[0];
                                }

                                resolve(itemArray);
                            
                            }
                        }
                    });
                }
            });
        
        }).then((auctions) => {

            commit('setAuctions', { auctions });

            // Remove loading
            commit('setAuctionLoading', { loading: false });

        });
    },

    getAuction ({ commit }, payload) {
        return new Promise((resolve, reject) => {  
            
            const args = "[\"" + payload.id + "\"]";
            nebPay.simulateCall(contractAddress, 0, 'getAuction', args, {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        console.log('error', 'auctions', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                        resolve({ message: 'error' });

                    } else {

                        let item = JSON.parse(data.result);                        
                        resolve({
                            message: 'success',
                            item
                        });

                    }
                }
            });

        });
    },

    getOpenAuctions ({ commit }, payload) {
        return new Promise((resolve, reject) => {  
            
            nebPay.simulateCall(contractAddress, 0, 'getOpenAuctions', "", {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        console.log('error', 'auctions', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                        resolve({ message: 'error' });

                    } else {

                        let itemArray = JSON.parse(data.result);  
                        
                        for (let i = 0; i < itemArray.length; i++) {
                            itemArray[i].card = transformDna([itemArray[i].card])[0];
                        }

                        resolve({
                            message: 'success',
                            auctions: itemArray
                        });

                    }
                }
            });

        });
    },

    getAuctionsByRange ({ commit }, payload) {
        return new Promise((resolve, reject) => {  
            
            const args = "[" + payload.start + "," + payload.end + "]";
            nebPay.simulateCall(contractAddress, 0, 'getAuctionsByRange', args, {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        console.log('error', 'auctions', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                        resolve({ message: 'error' });

                    } else {

                        let itemArray = JSON.parse(data.result);  
                        
                        for (let i = 0; i < itemArray.length; i++) {
                            itemArray[i].card = transformDna([itemArray[i].card])[0];
                        }

                        resolve({
                            message: 'success',
                            auctions: itemArray
                        });

                    }
                }
            });

        });
    },

    getAuctionsByAddress ({ commit }, payload) {
        return new Promise((resolve, reject) => {  
            
            const address = payload.address;
            const args = "[\"" + address + "\"]";

            if (!address) {
                return resolve({ auctions: [] });
            };

            nebPay.simulateCall(contractAddress, 0, 'getAuctionsByAddress', args, {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        console.log('error', 'auctions', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                        resolve({ message: 'error' });

                    } else {

                        let itemArray = JSON.parse(data.result);  
                        
                        for (let i = 0; i < itemArray.length; i++) {
                            itemArray[i].card = transformDna([itemArray[i].card])[0];
                        }

                        resolve({
                            message: 'success',
                            auctions: itemArray
                        });

                    }
                }
            });

        });
    },

    createAuction ({ commit }, payload) {
        const cardId = payload.cardId;
        const price = payload.price;
        const card = payload.card;

        // Contructs args in correct format
        const args = "[" + cardId + "," + price + "]";

        return new Promise((resolve, reject) => {   
            nebPay.call(contractAddress, 0, 'createNewAuction', args, {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {

                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {

                                        // TODO: Check to see if the topic is correct
                                        let auction = JSON.parse(result.events[0].data).NewAuction;   
                                        auction.card = card;
                    
                                        commit('addToAuctions', auction);

                                        // Update pending status
                                        commit('updatePendingTransaction', { status: false });

                                        // Resolve with success
                                        resolve({ message: 'success' });

                                    });
                                }

                            }).catch(error => {

                                clearInterval(pollApi);
                                
                                // Update pending status
                                commit('updatePendingTransaction', { status: false });

                                // Unlock if failed or canceld
                                commit('updateCardLockStatus', { id: cardId, isLocked: false, lockType: '' });

                                // Resolve with error
                                resolve({ message: 'error' });

                            });

                    }, 3000);
                }
            });
        });

    },

    buyAuction ({ commit }, payload) {
        const auction = payload.auction;
        const price = auction.price;
        const id = auction.id;

        // Contructs args in correct format
        const args = "[" + id + "]";
        return new Promise((resolve, reject) => {   
            nebPay.call(contractAddress, price, 'buyAuction', args, {
                listener: function(data) {
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {

                                        // Update card
                                        auction.card.isLocked = false;
                                        auction.card.lockType = '';
                                        auction.card.new = true;

                                        // Add to cards
                                        commit('addToCards', auction.card);

                                        // Update auction
                                        auction.isComplete = true;
                                        commit('updateAuctionCompleteStatus', { auction });
                                        
                                        // Resolve with error
                                        resolve({ message: 'success' });

                                    })
                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                            });
                    }, 3000);
                }              
            });
        });    
    },

    // *********** \\
    // - BATTLES - \\
    // *********** \\

    initBattles ({ commit, dispatch, getters }) {

        dispatch('getAllBattles').then((data) => {

            commit('setBattles', { battles: data.battles });
            commit('setFilteredBattles');
            
            // Remove loading
            commit('setBattleLoading', { loading: false });

        });

    },

    getBattle () {},

    getAllBattles ({ commit }) {
        return new Promise((resolve, reject) => {    

            let itemArray = [];

            nebPay.simulateCall(contractAddress, 0, 'getBattleCounter', "", {
                listener: function(data) {
                    const len = parseInt(data.result);
                    let errorCount = 0;

                    nebPay.simulateCall(contractAddress, 0, 'getAllBattles', "", {
                        listener: function(data) {  

                            // Catch a bad response
                            if (!data.result) {

                                errorCount += 1;
                                console.log('error', 'battles', data);
                                commit('setHasError', { error: {
                                    status: true,
                                    message: data
                                }});

                            } else {
                            
                                itemArray = JSON.parse(data.result);
                                resolve({ battles: itemArray });

                            }
                            
                        }
                    });
                }
            });
        });
    },

    getOpenBattles () {
        return new Promise((resolve, reject) => {    

            let itemArray = [];

            nebPay.simulateCall(contractAddress, 0, 'getOpenBattles', "", {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        errorCount += 1;
                        console.log('error', 'battles', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                    } else {
                    
                        itemArray = JSON.parse(data.result);
                        resolve({ 
                            message: 'success',
                            battles: itemArray
                        });

                    }
                    
                }
            });
        });
    },

    getBattlesByRange ({ commit }, payload) {
        return new Promise((resolve, reject) => {  
            
            const args = "[" + payload.start + "," + payload.end + "]";
            nebPay.simulateCall(contractAddress, 0, 'getBattlesByRange', args, {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        console.log('error', 'auctions', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                        resolve({ message: 'error' });

                    } else {

                        let itemArray = JSON.parse(data.result);  
                        resolve({
                            message: 'success',
                            battles: itemArray
                        });

                    }
                }
            });

        });
    },

    getBattlesByAddress ({ commit }, payload) {
        return new Promise((resolve, reject) => {  
            
            const address = payload.address;
            const args = "[\"" + address + "\"]";

            if (!address) {
                return resolve({ battles: [] });
            };

            nebPay.simulateCall(contractAddress, 0, 'getBattlesByAddress', args, {
                listener: function(data) {  

                    // Catch a bad response
                    if (!data.result) {

                        console.log('error', 'battles', data);
                        commit('setHasError', { error: {
                            status: true,
                            message: data
                        }});

                        resolve({ message: 'error' });

                    } else {

                        let itemArray = JSON.parse(data.result);  
                        
                        resolve({
                            message: 'success',
                            battles: itemArray
                        });

                    }
                }
            });
        });
    },

    createBattle ({ commit }, payload) {
        const cardBet = payload.cardBet;
        const cardIds = payload.cardIds;

        // Contructs args in correct format
        const args = "[" + cardBet + "," + cardIds + "]";
        return new Promise((resolve, reject) => {    

            nebPay.call(contractAddress, 0, 'createNewBattle', args, {
                listener: function(data) {
                    
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {
                                        const self = payload.self;

                                        // TODO: Check to see if the topic is correct
                                        let battle = JSON.parse(result.events[0].data).NewBattle;   

                                        // Update state with the new battle
                                        commit('addToBattles', battle);
                                        
                                        // Update filtered battles
                                        commit('setFilteredBattles');

                                        resolve({ message: 'success' });

                                    });
                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                            });
                    }, 3000);
                    
                }
            });
        });
    },

    commenceBattle ({ commit, state }, payload) {
        const cardBet = payload.cardBet;
        const cardIds = payload.cardIds;
        const battle = payload.battle;
        const opponent = state.user.address;

        // Contructs args in correct format
        const args = "[" + battle.id + "," + cardBet + "," + cardIds + "]";
        return new Promise((resolve, reject) => {    

            nebPay.call(contractAddress, 0, 'commenceBattle', args, {
                listener: function(data) {
                    
                    const pollApi = setInterval(() => {
                        api.getTransactionReceipt({ hash: data.txhash })
                            .then((res) => {
                                if(res.status === 1) {
                                    clearInterval(pollApi);

                                    api.getEventsByHash({ hash: data.txhash })
                                    .then(function(result) {
                                        let battleResult = JSON.parse(result.events[0].data).EndBattle;
                                        let winnerAddress;

                                        // Update win card ids for current user
                                        if (battleResult.winner == 'opponent') {
                                            winnerAddress = opponent;

                                            commit('addToCardsById', { id: battle.ownerCardBet });
                                            commit('updateCardLevel', { cards: [ battle.ownerCardBet, cardBet ]});
                                            commit('updateCardLockStatus', { id: cardBet, isLocked: false, lockType: '' });
                                            commit('updateCardLockStatus', { id: battle.ownerCardBet, isLocked: false, lockType: '' });
                                            commit('updateUserBattleStats', { status: 'win' });
                                        } else {
                                            winnerAddress = battle.owner;

                                            commit('removeFromCardsById', { id: cardBet });
                                            commit('updateUserBattleStats', { status: 'loss' });
                                        }

                                        // Update battle complete status
                                        commit('updateBattleCompleteState', { 
                                            id: battle.id, 
                                            isComplete: true,
                                            opponent: opponent,
                                            winner: winnerAddress,
                                            opponentCardIds: cardIds
                                        });

                                        resolve({ message: 'success', battleResult });

                                    });
                                }
                            }).catch(error => {

                                clearInterval(pollApi);
                                resolve({ message: 'error' });

                            });
                    }, 3000);
                    
                }
            });
        });
    },

    updateBattleCards ({ commit, state }, payload) {
        const ownerCards = [];
        const opponentCards = [];

        for (let i = 0; i < 3; i++) {
            for (let j = 0; j < state.allCards.length; j++) {

                if (state.allCards[j].id ==  payload.battle.ownerCardIds[i]) {
                    ownerCards.push(state.allCards[j]);
                }

                if (state.allCards[j].id ==  payload.battle.opponentCardIds[i]) {
                    opponentCards.push(state.allCards[j]);
                }

            }
        }
   
        // Battle results
        const results = battleLogic(ownerCards, opponentCards);

        // Update battleCards state
        commit('setBattleCards', { ownerCards, opponentCards });

        // Battle results mutation
        commit('updateBattleResults', { results });
    },

    // ********* \\
    // - USERS - \\
    // ********* \\

    initUsers ({ commit, dispatch }) {

        return new Promise((resolve, reject) => {      
            let userArray = [];

            nebPay.simulateCall(contractAddress, 0, 'getUserCounter', "", {
                listener: function(data) {
                    const len = parseInt(data.result);
                    let errorCount = 0;

                    if (len == 0) {
                        resolve([]);
                    }

                    nebPay.simulateCall(contractAddress, 0, 'getAllUsers', "", {
                        listener: function(data) {         
                            
                            // Catch a bad response
                            if (!data.result) {

                                errorCount += 1;
                                console.log('error', 'users', data);
                                commit('setHasError', { error: {
                                    status: true,
                                    message: data
                                }});

                            } else {

                                console.log('user', data)
                                userArray = JSON.parse(data.result);

                                for (let i = 0; i < userArray.length; i++) {

                                    const winCount = userArray[i].winCount;
                                    const lossCount = userArray[i].lossCount;
                                    const total = winCount + lossCount;
    
                                    userArray[i].winPercentage = winCount > 0 ? Math.round(winCount / (total) * 100) : 0;

                                }

                                resolve(userArray);
                     
                            }
                        }
                    });
                }
            });
        
        }).then((users) => {
            commit('setUsers', { users });
            commit('restoreUser');

            commit('setUserLoading', { loading: false });
        });

    },

    initLoaders ({ commit }) {
        
        // Start loading for all
        commit('setCardLoading', { loading: true });
        commit('setUserLoading', { loading: true });
        commit('setBattleLoading', { loading: true });
        commit('setAuctionLoading', { loading: true });
        commit('setCardCounterLoading', { loading: true });

    },

    // ********* \\
    // MIGRATION \\
    // ********* \\

    dumpCards ({ commit, getters }) {
        return new Promise((resolve, reject) => {      
            let localObject;
            const cardArray = [];
            const userCardArray = [];
            
            nebPay.simulateCall(contractAddress, 0, 'getCardCounter', "", {
                listener: function(data) {
                    const len = parseInt(data.result);
                    let errorCount = 0;

                    // Update created cards counter
                    commit('setCardsCreated', { cardsCreated: len });
                    commit('setCardCounterLoading', { loading: false });

                    for (let i = 1; i <= len; i++) {
                        const args = "[" + i + "]";                      
                        nebPay.simulateCall(contractAddress, 0, 'getCard', args, {
                            listener: function(data) {  
                                
                                // Catch a bad response
                                if (!data.result) {

                                    errorCount += 1;
                                    console.log('error', 'cards', data);
                                    commit('setHasError', { error: {
                                        status: true,
                                        message: data
                                    }});

                                } else {

                                    localObject = JSON.parse(data.result);
                                    localObject = transformDna([ localObject ])[0];
                                    cardArray.push(localObject);
                                            
                                    if (getters.getUser.address == localObject.owner) {
                                        userCardArray.push(localObject);
                                    }

                                    if (cardArray.length == len - errorCount) {
                                        resolve({
                                            allCards: cardArray,
                                            userCards: userCardArray
                                        });
                                    }

                                }

                            }
                        });
                    }
                }
            });
        
        }).then((cardsObject) => {
            console.log('cardsObject', cardsObject)
            commit('setCards', { cards: cardsObject.userCards });
            commit('setAllCards', { cards: cardsObject.allCards }); 

            commit('setCardLoading', { loading: false });
        });
    },

    dumpUsers ({ commit }) {
        return new Promise((resolve, reject) => {      
            const userArray = [];
            let localObject;

            nebPay.simulateCall(contractAddress, 0, 'getUserCounter', "", {
                listener: function(data) {
                    console.log('user counter', data)

                    const len = parseInt(data.result);
                    let errorCount = 0;

                    for (let i = 1; i <= len; i++) {
                        nebPay.simulateCall(contractAddress, 0, 'getUser', "[" + i + "]", {
                            listener: function(data) {         
                                
                                // Catch a bad response
                                if (!data.result) {

                                    errorCount += 1;
                                    console.log('error', 'users', data);
                                    commit('setHasError', { error: {
                                        status: true,
                                        message: data
                                    }});

                                } else {

                                    localObject = JSON.parse(data.result);

                                    const winCount = localObject.winCount;
                                    const lossCount = localObject.lossCount;
                                    const total = winCount + lossCount;

                                    localObject.id = i;
                                    localObject.winPercentage = winCount > 0 ? Math.round(winCount / (total) * 100) : 0;

                                    userArray.push(localObject);        
                                    if (userArray.length == len - errorCount) {
                                        resolve(userArray);
                                    }
                                
                                }
                            }
                        });
                    }
                }
            });
        
        }).then((users) => {
            commit('setUsers', { users });
            commit('restoreUser');

            console.log('here user ... ')

            commit('setUserLoading', { loading: false });
        });
    }

}


// WEBPACK FOOTER //
// ./src/store/actions.js